// packages
import { Component, h } from 'preact';
import cx from 'classnames';

// components
import CandidateRow from './components/CandidateRow';
import Contest from './components/Contest';
import NewContestShowcase from './components/NewContestShowcase';
import BalancePower from './components/BalancePower';
import MiniBalancePower from './components/MiniBalancePower';
import YourRaces from './components/YourRaces';
import Portal from './components/Portal';
import AnalysisTable from './components/AnalysisTable';

import find from './utils/find';
import {
  determineContestTitle,
  lastUpdatedFormat,
  chunk,
  sort_candidates_by_party,
} from './election-utils';
import {
  RESULTS_IN_USE,
  visibleCandidatesCount,
  DDHQestimatedvotes,
  showCategoriesMap,
  showPrecinctsReporting
} from './endpoints';
import getJSON from './utils/get-json';
import { LENGTH_OF_CHECK_INTERVAL } from './constants';

import Ad from './components/Ad';
import { lookup } from './photoMap';
import sumValues from './utils/sum-values';
import formatPercent from './utils/format-percent';

import analysisData from 'Data/data.json';

type State = {
  data: { [key: string]: any },
  now: Date | null,
};

class App extends Component<{}, State> {
  //   timer!: number;

  constructor() {
    super();

    this.state = {
      data: [],
      now: null,
      timer: 0,
    };

    this.fetchData = this.fetchData.bind(this);
    this.prepareData = this.prepareData.bind(this);
  }

  fetchData() {
    const now = new Date();
    console.info('Requesting:', now);

    const asOf = lastUpdatedFormat(now);

    // Uncomment if you want to bring back last updated in sticky bar

    // document.querySelector('.counter').innerHTML = asOf;

    // document.querySelector('.counter-mobile .counter').innerHTML = asOf;

    getJSON(RESULTS_IN_USE).then((data) =>
      this.setState({ data, asOf }, this.startTimer)
    );
  }

  prepareData(data, className, chamber, total, halfway) {
    let republican = 0,
      democrat = 0,
      vacant = 0,
      uncontested_republican = 0,
      uncontested_democrat = 0;

    data.forEach((contest) => {
      // console.log(contest)
      if (
        contest.contest_result == 'not called' &&
        contest.candidacies.length > 1
      ) {
        vacant++;
      } else if (
        (contest.contest_result == 'not called' ||
          contest.contest_result == 'uncontested') &&
        contest.candidacies.length == 1 &&
        contest.candidacies[0].party == 'Republican'
      ) {
        uncontested_republican++;
      } else if (
        (contest.contest_result == 'not called' ||
          contest.contest_result == 'uncontested') &&
        contest.candidacies.length == 1 &&
        contest.candidacies[0].party == 'Democrat'
      ) {
        uncontested_democrat++;
      } else if (
        contest.contest_result == 'winner' &&
        contest.candidacies.length > 1 &&
        find(contest.candidacies, (candidate) => candidate.is_winner === true) && 
        find(contest.candidacies, (candidate) => candidate.is_winner === true)
          .party == 'Republican'
      ) {
        republican++;
      } else if (
        contest.contest_result == 'winner' &&
        contest.candidacies.length > 1 &&
        find(contest.candidacies, (candidate) => candidate.is_winner === true) && 
        find(contest.candidacies, (candidate) => candidate.is_winner === true)
          .party == 'Democrat'
      ) {
        democrat++;
      }
    });

    return {
      chamber: chamber,
      className: className,
      republican: republican,
      democrat: democrat,
      vacant: vacant,
      halfway: halfway,
      total: total,
      uncontested_republican: uncontested_republican,
      uncontested_democrat: uncontested_democrat,
    };
  }

  startTimer() {
    this.timer = window.setTimeout(this.fetchData, LENGTH_OF_CHECK_INTERVAL);
  }

  clearTimer() {
    window.clearTimeout(this.timer);
  }

  componentDidMount() {
    this.fetchData();
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  componentDidUpdate() {}

  render() {
    const { notes, annotations } = this.props;
    const { data, asOf } = this.state;

    // In order to sprinkle ads between races in sections where there a lot of races like the Texas House, we need to divide them into groups of nth races to make it into different divs

    const texasHouse = data.filter(
      (contest) => contest.office === 'Texas House'
    );

    const usHouse = data.filter((contest) => contest.office === 'U.S. House');

    let texasHouseGroups, usHouseGroups;

    if (texasHouse.length) {
      texasHouseGroups = chunk(texasHouse, 28);
      usHouseGroups = chunk(usHouse, 24);
    }

    const pastPowerBalance = analysisData['past_balance_of_power'];

    const checkmark = '\u2713';

    // {cx('check', {
    //   'rep-winner': candidate.party == 'Republican',
    //   'dem-winner': candidate.party == 'Democrat',
    // })}

    return (
      <div class="results">
        <Portal
          node={document.getElementById('lookup-select')}
          ref={(ref) => (this._yourPortal = ref)}
        >
          <YourRaces
            contests={data}
            notes={notes}
            annotations={annotations}
            asOf={asOf}
          />
        </Portal>

        <Portal
          node={document.querySelector('.headshot-results')}
          ref={(ref) => (this._yourPortal = ref)}
        >
          {data &&
            data
              .filter((chamber) => chamber.office == 'Governor')
              .map((chamber, i) => (
                <div class="headshot-result">
                  <div class="headshot-title"><a href={`#${chamber.office_slug}`} class='anchor'>{chamber.office}</a></div>
                  <div class="top-candidates">
                    {sort_candidates_by_party(chamber.candidacies)
                      .filter(
                        (candidate) =>
                          candidate.name === 'Greg Abbott' ||
                          candidate.name === "Beto O'Rourke"
                      )
                      .map((candidate) => (
                        <div class="top-candidate">
                          <img
                            class={'headshot'}
                            alt={`Headshot of ` + candidate.name}
                            src={lookup.get(candidate.name)}
                          />
                          <div
                            class={cx('top-candidate-name', {
                              dd_winner_rep: candidate.party == 'Republican',
                              dd_winner_dem: candidate.party == 'Democrat',
                            })}
                          >
                            {candidate.is_winner == true && (
                              <span class="check">{checkmark}</span>
                            )}
                            {candidate.name.split(' ')[1]}{' '}
                          </div>
                          <div class="top-candidate-votes">
                            {formatPercent(
                              candidate.votes,
                              sumValues(chamber.candidacies, 'votes')
                            )}
                            %
                          </div>
                        </div>
                      ))}
                  </div>
                 {showPrecinctsReporting == true && ( <p class="contest__precincts">
                    {formatPercent(
                      sumValues(chamber.candidacies, 'votes'),
                      chamber[DDHQestimatedvotes]
                    ) < 100
                      ? `${formatPercent(
                          sumValues(chamber.candidacies, 'votes'),
                          chamber[DDHQestimatedvotes]
                        )}% votes counted`
                      : `>99% votes counted`}
                  </p>)}
                </div>
              ))}
        </Portal>

        {data &&
          pastPowerBalance
            .filter((chamber) => chamber.chamber !== 'U.S. House')
            .map((chamber) => (
              <Portal
                node={document.querySelector(`.mini-${chamber.className}`)}
                ref={(ref) => (this._usPortal = ref)}
              >
                <div class="mini-balance-of-power">
                  <div class="headshot-title">
                    {data.length > 0 && (<a href={`#${chamber.className}`} class='anchor'>{chamber.chamber}</a>)}
                  </div>
                  <MiniBalancePower
                    className={chamber.className}
                    currentData={this.prepareData(
                      data.filter(
                        (contest) => contest.office === chamber.chamber
                      ),
                      chamber.className,
                      chamber.chamber,
                      chamber.total_current,
                      chamber.halfway
                    )}
                  />
                </div>
              </Portal>
            ))}

        <NewContestShowcase
          contest={find(data, (contest) => contest.office === 'Governor')}
          container={document.querySelector('#governor')}
          annotations={annotations.filter((item) => item.type === 'governor')}
          asOf={asOf}
        />
        <NewContestShowcase
          contest={find(
            data,
            (contest) => contest.office === 'Attorney General'
          )}
          container={document.querySelector('#attorney-general')}
          annotations={annotations.filter(
            (item) => item.type === 'attorney-general'
          )}
          asOf={asOf}
        />

       

        {data &&
          pastPowerBalance.map((chamber) => (
            <Portal
              node={document.querySelector(
                `.${chamber.className}-balance-graphic`
              )}
              ref={(ref) => (this._usPortal = ref)}
            >
              <div class="balance-of-power-container">
                <BalancePower
                  pastData={chamber}
                  chamber={chamber.chamber}
                  className={chamber.className}
                  currentData={this.prepareData(
                    data.filter(
                      (contest) => contest.office === chamber.chamber
                    ),
                    chamber.className,
                    chamber.chamber,
                    chamber.total_current,
                    chamber.halfway
                  )}
                />
              </div>
            </Portal>
          ))}

{data &&
          showCategoriesMap &&
          data
            .filter(
              (contest) =>
                contest.office == 'Governor' ||
                contest.office == 'Attorney General'
            )
            .map((contest) => (
              <Portal
                node={document.querySelector(
                  `.contest-counties-container.${contest.office_slug}`
                )}
                ref={(ref) => (this._usPortal = ref)}
              >
                <AnalysisTable
                  contest={contest}
                  candidates={contest.candidacies.filter(
                    (candidate) =>
                      candidate.name === "Beto O'Rourke" ||
                      candidate.name === 'Greg Abbott' ||
                      candidate.name === 'Ken Paxton' ||
                      candidate.name === 'Rochelle Garza'
                  )}
                  counties={contest.counties}
                />
              </Portal>
            ))}

        <Portal
          node={document.querySelector('#us-house .contests')}
          ref={(ref) => (this._usPortal = ref)}
        >
          <div class="office__contests">
            {usHouse.length > 0 &&
              usHouseGroups.map((contestGroup) => (
                <div class="contest-group">
                  <div class="seat__contests-double">
                    {contestGroup.map((contest) => (
                      <Contest
                        key={contest.id}
                        contest={contest}
                        tableHeader={CandidateRow.Header}
                        columnCount={CandidateRow.columnCount}
                        contestTitle={determineContestTitle(
                          data.filter(
                            (item) => item.office_slug === contest.office_slug
                          )[0]
                        )}
                        partyName={contest.party}
                        annotations={annotations.filter(
                          (item) => item.type === contest.office_slug
                        )}
                        notes={notes.filter(
                          (item) => item.type === contest.office_slug
                        )}
                        source={contest.source}
                        asOf={asOf}
                        renderCandidate={(
                          candidate,
                          idx,
                          viewAllCandidates,
                          { totalVotes }
                        ) => (
                          <CandidateRow
                            ballotName={candidate.name}
                            contestOffice={contest.office}
                            contestIsCalled={contest.is_called}
                            contestResult={contest.contest_result}
                            isIncumbent={candidate.is_incumbent}
                            isWinner={candidate.is_winner}
                            isViewable={
                              viewAllCandidates || idx < visibleCandidatesCount
                            }
                            party={candidate.party}
                            totalVotesInContest={totalVotes}
                            votes={candidate.votes}
                          />
                        )}
                      />
                    ))}
                  </div>
                  <Ad />
                </div>
              ))}
          </div>
        </Portal>
        <Portal
          node={document.querySelector('#lieutenant-governor .contests')}
          ref={(ref) => (this._supremePortal = ref)}
        >
          <div class="office__contests">
            <div class="seat__contests-single">
              {data
                .filter((contest) => contest.office === 'Lieutenant Governor')
                .map((contest) => (
                  <Contest
                    key={contest.id}
                    contest={contest}
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        (item) => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    partyName={contest.party}
                    annotations={annotations.filter(
                      (item) => item.type === contest.office_slug
                    )}
                    notes={notes.filter(
                      (item) => item.type === contest.office_slug
                    )}
                    source={contest.source}
                    asOf={asOf}
                    renderCandidate={(
                      candidate,
                      idx,
                      viewAllCandidates,
                      { totalVotes }
                    ) => (
                      <CandidateRow
                        ballotName={candidate.name}
                        contestOffice={contest.office}
                        contestIsCalled={contest.is_called}
                        contestResult={contest.contest_result}
                        candidatesNum={contest.candidacies.length}
                        isIncumbent={candidate.is_incumbent}
                        isWinner={candidate.is_winner}
                        isViewable={
                          viewAllCandidates || idx < visibleCandidatesCount
                        }
                        party={candidate.party}
                        totalVotesInContest={totalVotes}
                        votes={candidate.votes}
                      />
                    )}
                  />
                ))}
            </div>
          </div>
        </Portal>
        <Portal
          node={document.querySelector('#land-commissioner .contests')}
          ref={(ref) => (this._supremePortal = ref)}
        >
          <div class="office__contests">
            <div class="seat__contests-single">
              {data
                .filter((contest) => contest.office === 'Land Commissioner')
                .map((contest) => (
                  <Contest
                    key={contest.id}
                    contest={contest}
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        (item) => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    partyName={contest.party}
                    annotations={annotations.filter(
                      (item) => item.type === contest.office_slug
                    )}
                    notes={notes.filter(
                      (item) => item.type === contest.office_slug
                    )}
                    source={contest.source}
                    asOf={asOf}
                    renderCandidate={(
                      candidate,
                      idx,
                      viewAllCandidates,
                      { totalVotes }
                    ) => (
                      <CandidateRow
                        ballotName={candidate.name}
                        contestOffice={contest.office}
                        contestIsCalled={contest.is_called}
                        contestResult={contest.contest_result}
                        candidatesNum={contest.candidacies.length}
                        isIncumbent={candidate.is_incumbent}
                        isWinner={candidate.is_winner}
                        isViewable={
                          viewAllCandidates || idx < visibleCandidatesCount
                        }
                        party={candidate.party}
                        totalVotesInContest={totalVotes}
                        votes={candidate.votes}
                      />
                    )}
                  />
                ))}
            </div>
          </div>
        </Portal>
        <Portal
          node={document.querySelector('#comptroller .contests')}
          ref={(ref) => (this._supremePortal = ref)}
        >
          <div class="office__contests">
            <div class="seat__contests-single">
              {data
                .filter((contest) => contest.office === 'Comptroller')
                .map((contest) => (
                  <Contest
                    key={contest.id}
                    contest={contest}
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        (item) => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    partyName={contest.party}
                    annotations={annotations.filter(
                      (item) => item.type === contest.office_slug
                    )}
                    notes={notes.filter(
                      (item) => item.type === contest.office_slug
                    )}
                    source={contest.source}
                    asOf={asOf}
                    renderCandidate={(
                      candidate,
                      idx,
                      viewAllCandidates,
                      { totalVotes }
                    ) => (
                      <CandidateRow
                        ballotName={candidate.name}
                        contestOffice={contest.office}
                        contestIsCalled={contest.is_called}
                        contestResult={contest.contest_result}
                        candidatesNum={contest.candidacies.length}
                        isIncumbent={candidate.is_incumbent}
                        isWinner={candidate.is_winner}
                        isViewable={
                          viewAllCandidates || idx < visibleCandidatesCount
                        }
                        party={candidate.party}
                        totalVotesInContest={totalVotes}
                        votes={candidate.votes}
                      />
                    )}
                  />
                ))}
            </div>
          </div>
        </Portal>
        <Portal
          node={document.querySelector('#agriculture-commissioner .contests')}
          ref={(ref) => (this._supremePortal = ref)}
        >
          <div class="office__contests">
            <div class="seat__contests-single">
              {data
                .filter(
                  (contest) => contest.office === 'Agriculture Commissioner'
                )
                .map((contest) => (
                  <Contest
                    key={contest.id}
                    contest={contest}
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        (item) => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    partyName={contest.party}
                    annotations={annotations.filter(
                      (item) => item.type === contest.office_slug
                    )}
                    notes={notes.filter(
                      (item) => item.type === contest.office_slug
                    )}
                    source={contest.source}
                    asOf={asOf}
                    renderCandidate={(
                      candidate,
                      idx,
                      viewAllCandidates,
                      { totalVotes }
                    ) => (
                      <CandidateRow
                        ballotName={candidate.name}
                        contestOffice={contest.office}
                        contestIsCalled={contest.is_called}
                        contestResult={contest.contest_result}
                        candidatesNum={contest.candidacies.length}
                        isIncumbent={candidate.is_incumbent}
                        isWinner={candidate.is_winner}
                        isViewable={
                          viewAllCandidates || idx < visibleCandidatesCount
                        }
                        party={candidate.party}
                        totalVotesInContest={totalVotes}
                        votes={candidate.votes}
                      />
                    )}
                  />
                ))}
            </div>
          </div>
        </Portal>
        <Portal
          node={document.querySelector(
            '#railroad-commission-of-texas .contests'
          )}
          ref={(ref) => (this._supremePortal = ref)}
        >
          <div class="office__contests">
            <div class="seat__contests-single">
              {data
                .filter(
                  (contest) => contest.office === 'Texas Railroad Commission'
                )
                .map((contest) => (
                  <Contest
                    key={contest.id}
                    contest={contest}
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        (item) => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    partyName={contest.party}
                    annotations={annotations.filter(
                      (item) => item.type === contest.office_slug
                    )}
                    notes={notes.filter(
                      (item) => item.type === contest.office_slug
                    )}
                    source={contest.source}
                    asOf={asOf}
                    renderCandidate={(
                      candidate,
                      idx,
                      viewAllCandidates,
                      { totalVotes }
                    ) => (
                      <CandidateRow
                        ballotName={candidate.name}
                        contestOffice={contest.office}
                        contestIsCalled={contest.is_called}
                        contestResult={contest.contest_result}
                        candidatesNum={contest.candidacies.length}
                        isIncumbent={candidate.is_incumbent}
                        isWinner={candidate.is_winner}
                        isViewable={
                          viewAllCandidates || idx < visibleCandidatesCount
                        }
                        party={candidate.party}
                        totalVotesInContest={totalVotes}
                        votes={candidate.votes}
                      />
                    )}
                  />
                ))}
            </div>
          </div>
        </Portal>
        <Portal
          node={document.querySelector('#state-board-of-education .contests')}
          ref={(ref) => (this._sboePortal = ref)}
        >
          <div class="office__contests">
            <div class="seat__contests-double">
              {data
                .filter(
                  (contest) => contest.office === 'State Board of Education'
                )
                .map((contest) => (
                  <Contest
                    key={contest.id}
                    contest={contest}
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        (item) => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    partyName={contest.party}
                    annotations={annotations.filter(
                      (item) => item.type === contest.office_slug
                    )}
                    notes={notes.filter(
                      (item) => item.type === contest.office_slug
                    )}
                    source={contest.source}
                    asOf={asOf}
                    renderCandidate={(
                      candidate,
                      idx,
                      viewAllCandidates,
                      { totalVotes }
                    ) => (
                      <CandidateRow
                        ballotName={candidate.name}
                        contestOffice={contest.office}
                        contestIsCalled={contest.is_called}
                        contestResult={contest.contest_result}
                        candidatesNum={contest.candidacies.length}
                        isIncumbent={candidate.is_incumbent}
                        isWinner={candidate.is_winner}
                        isViewable={
                          viewAllCandidates || idx < visibleCandidatesCount
                        }
                        party={candidate.party}
                        totalVotesInContest={totalVotes}
                        votes={candidate.votes}
                      />
                    )}
                  />
                ))}
            </div>
          </div>
        </Portal>
        <Portal
          node={document.querySelector('#texas-supreme-court .contests')}
          ref={(ref) => (this._sboePortal = ref)}
        >
          <div class="office__contests">
            <div class="seat__contests-double">
              {data
                .filter((contest) => contest.office === 'Texas Supreme Court')
                .map((contest) => (
                  <Contest
                    key={contest.id}
                    contest={contest}
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        (item) => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    partyName={contest.party}
                    annotations={annotations.filter(
                      (item) => item.type === contest.office_slug
                    )}
                    notes={notes.filter(
                      (item) => item.type === contest.office_slug
                    )}
                    source={contest.source}
                    asOf={asOf}
                    renderCandidate={(
                      candidate,
                      idx,
                      viewAllCandidates,
                      { totalVotes }
                    ) => (
                      <CandidateRow
                        ballotName={candidate.name}
                        contestOffice={contest.office}
                        contestIsCalled={contest.is_called}
                        contestResult={contest.contest_result}
                        candidatesNum={contest.candidacies.length}
                        isIncumbent={candidate.is_incumbent}
                        isWinner={candidate.is_winner}
                        isViewable={
                          viewAllCandidates || idx < visibleCandidatesCount
                        }
                        party={candidate.party}
                        totalVotesInContest={totalVotes}
                        votes={candidate.votes}
                      />
                    )}
                  />
                ))}
            </div>
          </div>
        </Portal>
        <Portal
          node={document.querySelector(
            '#texas-court-of-criminal-appeals .contests'
          )}
          ref={(ref) => (this._sboePortal = ref)}
        >
          <div class="office__contests">
            <div class="seat__contests-double">
              {data
                .filter(
                  (contest) =>
                    contest.office === 'Texas Court of Criminal Appeals'
                )
                .map((contest) => (
                  <Contest
                    key={contest.id}
                    contest={contest}
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        (item) => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    partyName={contest.party}
                    annotations={annotations.filter(
                      (item) => item.type === contest.office_slug
                    )}
                    notes={notes.filter(
                      (item) => item.type === contest.office_slug
                    )}
                    source={contest.source}
                    asOf={asOf}
                    renderCandidate={(
                      candidate,
                      idx,
                      viewAllCandidates,
                      { totalVotes }
                    ) => (
                      <CandidateRow
                        ballotName={candidate.name}
                        contestOffice={contest.office}
                        contestIsCalled={contest.is_called}
                        contestResult={contest.contest_result}
                        candidatesNum={contest.candidacies.length}
                        isIncumbent={candidate.is_incumbent}
                        isWinner={candidate.is_winner}
                        isViewable={
                          viewAllCandidates || idx < visibleCandidatesCount
                        }
                        party={candidate.party}
                        totalVotesInContest={totalVotes}
                        votes={candidate.votes}
                      />
                    )}
                  />
                ))}
            </div>
          </div>
        </Portal>
        <Portal
          node={document.querySelector('#texas-senate .contests')}
          ref={(ref) => (this._senatePortal = ref)}
        >
          <div class="office__contests">
            <div class="seat__contests-double">
              {data
                .filter((contest) => contest.office === 'Texas Senate')
                .map((contest) => (
                  <Contest
                    key={contest.id}
                    contest={contest}
                    tableHeader={CandidateRow.Header}
                    columnCount={CandidateRow.columnCount}
                    contestTitle={determineContestTitle(
                      data.filter(
                        (item) => item.office_slug === contest.office_slug
                      )[0]
                    )}
                    partyName={contest.party}
                    annotations={annotations.filter(
                      (item) => item.type === contest.office_slug
                    )}
                    notes={notes.filter(
                      (item) => item.type === contest.office_slug
                    )}
                    source={contest.source}
                    asOf={asOf}
                    renderCandidate={(
                      candidate,
                      idx,
                      viewAllCandidates,
                      { totalVotes }
                    ) => (
                      <CandidateRow
                        ballotName={candidate.name}
                        contestOffice={contest.office}
                        contestIsCalled={contest.is_called}
                        contestResult={contest.contest_result}
                        candidatesNum={contest.candidacies.length}
                        isIncumbent={candidate.is_incumbent}
                        isWinner={candidate.is_winner}
                        isViewable={
                          viewAllCandidates || idx < visibleCandidatesCount
                        }
                        party={candidate.party}
                        totalVotesInContest={totalVotes}
                        votes={candidate.votes}
                      />
                    )}
                  />
                ))}
            </div>
          </div>
        </Portal>

        <Portal
          node={document.querySelector('#texas-house .contests')}
          ref={(ref) => (this._housePortal = ref)}
        >
          <div class="office__contests">
            {texasHouse.length > 0 &&
              texasHouseGroups.map((contestGroup) => (
                <div class="contest-group">
                  <div class="seat__contests-double">
                    {contestGroup.map((contest) => (
                      <Contest
                        key={contest.id}
                        contest={contest}
                        tableHeader={CandidateRow.Header}
                        columnCount={CandidateRow.columnCount}
                        contestTitle={determineContestTitle(
                          data.filter(
                            (item) => item.office_slug === contest.office_slug
                          )[0]
                        )}
                        partyName={contest.party}
                        annotations={annotations.filter(
                          (item) => item.type === contest.office_slug
                        )}
                        notes={notes.filter(
                          (item) => item.type === contest.office_slug
                        )}
                        source={contest.source}
                        asOf={asOf}
                        renderCandidate={(
                          candidate,
                          idx,
                          viewAllCandidates,
                          { totalVotes }
                        ) => (
                          <CandidateRow
                            ballotName={candidate.name}
                            contestOffice={contest.office}
                            contestIsCalled={contest.is_called}
                            contestResult={contest.contest_result}
                            candidatesNum={contest.candidacies.length}
                            isIncumbent={candidate.is_incumbent}
                            isWinner={candidate.is_winner}
                            isViewable={
                              viewAllCandidates || idx < visibleCandidatesCount
                            }
                            party={candidate.party}
                            totalVotesInContest={totalVotes}
                            votes={candidate.votes}
                          />
                        )}
                      />
                    ))}
                  </div>
                  <Ad />
                </div>
              ))}
          </div>
        </Portal>
      </div>
    );
  }
}

export default App;
